import React from 'react';
import Joyride from 'react-joyride';

const OnBoardingComponent = props => {
  const {
    onBoardingDefinition,
    overrideOnStepChangeCallBack, // function: This function will be called when the tour changes its state (start, change in step, end, etc.)
    stepIndex,
    runTour,
    showProgress,
    styles,
  } = props;
  let defaultStyles = {
    tooltipContent: {
      textAlign: 'justify',
      paddingLeft: "12px",
      paddingRight: "12px",
      paddingTop: "26px",
      paddingBottom: "26px",
    },
    spotlight: {
      marginTop: "-5px",
    },
  }
  let tooltipStyles = styles || defaultStyles
  return (
    <Joyride
      run={runTour}
      steps={onBoardingDefinition.steps}
      locale={{ back: 'Atras', close: "Siguiente2", last: "Finalizar", next: "Siguiente", open: 'Abrir tour', skip: "Saltar Tour" }}
      styles={tooltipStyles}
      showProgress={showProgress!=null ? showProgress : true}
      continuous={true}
      showSkipButton={true}
      callback={overrideOnStepChangeCallBack || undefined}
      stepIndex={stepIndex || undefined}
      disableScrollParentFix={true}
      hideCloseButton={true} // Button doesn't exit the tour correctly
      disableScrolling={true}
      disableCloseOnEsc={true}
      disableOverlayClose={true}
    />
  );
};

export default OnBoardingComponent;



// WEBPACK FOOTER //
// ./source/client/components/common/interface/onBoardingComponent.jsx